import { IMG, APPLY, sized } from "@/lib/content";
import { Reveal } from "@/components/public/Reveal";
import { Btn, PageHead, SectionHead, Photo, Checks, CTA, DimLine, Eyebrow } from "@/components/public/ui";

const PERKS = [
  "Variasjon: bustad, næringsbygg, tunnel og industri",
  "Godkjend lærebedrift med eigne instruktørar",
  "Lokal arbeidsplass i Rosendal, på Husnes eller Halsnøy",
  "Del av eit større fagmiljø gjennom EQVA-konsernet",
];

export default function Careers() {
  return (
    <div data-testid="public-careers-page">
      <PageHead
        eyebrow="Karriere"
        title="Jobb hos Kvinnherad Elektro."
        lead="Vi er godkjend lærebedrift og har oppdrag frå bustad til tunnel og industri. Her jobbar du på ekte anlegg, saman med folk som kan faget."
        actions={<Btn href="#sok" size="lg" arrow data-testid="public-careers-jobs-button">Send søknad</Btn>}
      />

      <section className="container-public mt-10 sm:mt-14">
        <div className="grid gap-6 lg:grid-cols-12">
          <Photo className="lg:col-span-8" src={sized(IMG.electrician_pair, 2400)} alt="To elektrikarar med hjelm og verneutstyr i arbeid" ratio="aspect-[4/3] sm:aspect-[16/10]" sizes="(min-width: 1024px) 60vw, 100vw" priority />
          <Photo className="hidden lg:col-span-4 lg:block" src={sized(IMG.electrician_blue, 1200)} alt="Ung elektrikar i fordelingsskap" ratio="aspect-[4/3] sm:aspect-[16/10] lg:aspect-auto lg:h-full" imgClass="lg:absolute lg:inset-0" />
        </div>
      </section>

      <section className="container-public pt-24 sm:pt-32" data-testid="public-careers-why">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-7">
            <h2 className="t-h2 text-ink">Ein vanleg veke hos oss</h2>
            <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-muted-foreground">
              <p>Måndag kan vere eit sikringsskap i Rosendal. Onsdag ei tavle på Husnes. Fredag natt ei stenging i ein tunnel. Vi er store nok til å ha spennande prosjekt, og små nok til at du blir sett.</p>
              <p>Du jobbar saman med erfarne fagfolk, og får vere med på heile spennet frå service heime hos folk til industri og samferdsel.</p>
            </div>
          </Reveal>
          <Reveal delay={0.06} className="lg:col-span-5">
            <div className="rounded-pub bg-paper p-6 sm:p-8">
              <Eyebrow>Det du får</Eyebrow>
              <Checks items={PERKS} className="mt-5" />
            </div>
          </Reveal>
        </div>
      </section>

      <section id="sok" className="container-public scroll-mt-24 pt-24 sm:pt-32" data-testid="public-careers-jobs">
        <SectionHead eyebrow="Søknad" title="Send søknad" text="Vi lyser ikkje alltid ut stillingar. Fortel oss kven du er og kva du vil jobbe med, så tek vi kontakt." />
        <DimLine className="mt-10" />
        <ul className="divide-y divide-border">
          {APPLY.map((j) => (
            <li key={j.title} className="grid gap-4 py-7 lg:grid-cols-12 lg:gap-8" data-testid="public-job-row">
              <div className="lg:col-span-4">
                <h3 className="t-h3 text-ink">{j.title}</h3>
              </div>
              <p className="text-[15px] leading-relaxed text-muted-foreground lg:col-span-6">{j.text}</p>
              <div className="lg:col-span-2 lg:justify-self-end">
                <Btn to={`/kontakt?emne=${encodeURIComponent(`Søknad: ${j.title}`)}`} variant="outline" size="md" data-testid="public-job-apply-button">Søk</Btn>
              </div>
            </li>
          ))}
        </ul>
        <DimLine />
      </section>

      <section className="container-public pt-24 sm:pt-32" data-testid="public-careers-apprentice">
        <div className="grid gap-10 rounded-pub bg-paper p-7 sm:p-10 lg:grid-cols-12 lg:gap-16 lg:p-14">
          <div className="lg:col-span-7">
            <Eyebrow className="mb-5">Lærling</Eyebrow>
            <h2 className="t-h2 text-ink">Lærling hos oss</h2>
            <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-muted-foreground">Kvinnherad Elektro er godkjend lærebedrift. Som lærling får du vere med på alt frå bustad til tunnel og industri, med erfarne fagfolk rundt deg fram mot fagprøva.</p>
            <Btn to={`/kontakt?emne=${encodeURIComponent("Søknad: Lærlingplass")}`} variant="dark" size="md" arrow className="mt-8" data-testid="public-careers-apprentice-button">Søk lærlingplass</Btn>
          </div>
          <div className="lg:col-span-5">
            <Photo src={sized(IMG.electrician_kneel, 1200)} alt="Elektrikar arbeider i tavle" ratio="aspect-[4/3]" />
          </div>
        </div>
      </section>

      <div className="pt-24 sm:pt-32">
        <CTA />
      </div>
    </div>
  );
}
